// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section___xslj","background":"section_background__xBnYM"};